// Reconstructed from the supplied production build; original component names were unavailable.
import { React } from "../vendor/runtime.js";
import { api } from "../api/client.js";
const ProductSupportChat = ({ productId: a, userId: n }) => {
  const [i, l] = React.useState([]),
    [c, u] = React.useState(""),
    [m, f] = React.useState(false),
    [x, p] = React.useState(30),
    [g, b] = React.useState(null),
    [y, w] = React.useState(null),
    N = React.useRef(null);
  (React.useEffect(() => {
    (async () => {
      try {
        const M = await api.get(`/chat/remaining/${a}/${n}`);
        p(M.data.remaining);
      } catch (M) {
        (console.error("Error fetching remaining messages:", M),
          b("Unable to load message quota. Please try again later."));
      }
    })();
  }, [a, n]),
    React.useEffect(() => {
      var O;
      (O = N.current) == null ||
        O.scrollIntoView({
          behavior: "smooth",
        });
    }, [i]),
    React.useEffect(() => {
      if (y !== null) {
        const O = setTimeout(() => {
          w(null);
        }, 2e3);
        return () => clearTimeout(O);
      }
    }, [y]));
  const T = (O) => {
      if (!O) return "";
      let M = O.replace(
        /```([^`]+)```/g,
        '<pre class="bg-gray-100 p-2 rounded-md overflow-x-auto my-2 text-xs font-mono whitespace-pre-wrap break-words">$1</pre>',
      );
      return (
        (M = M.replace(
          /`([^`]+)`/g,
          '<code class="bg-gray-100 px-1 rounded text-xs font-mono break-words">$1</code>',
        )),
        (M = M.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")),
        (M = M.replace(/\*(.*?)\*/g, "<i>$1</i>")),
        (M = M.replace(
          /(https?:\/\/[^\s]+)/g,
          '<a href="$1" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline break-all">$1</a>',
        )),
        (M = M.replace(/^\d+\.\s(.+)$/gm, '<li class="break-words">$1</li>')),
        (M = M.replace(/^-\s(.+)$/gm, '<li class="break-words">$1</li>')),
        (M = M.replace(/\n/g, "<br>")),
        M
      );
    },
    C = (O, M) => {
      navigator.clipboard
        .writeText(O)
        .then(() => {
          w(M);
        })
        .catch((Y) => {
          console.error("Failed to copy text: ", Y);
        });
    },
    A = async (O) => {
      if ((O.preventDefault(), !c.trim() || m)) return;
      if (x <= 0) {
        b("You have reached your message limit for this product.");
        return;
      }
      const M = {
        id: Date.now().toString(),
        sender: "user",
        content: c.trim(),
        timestamp: new Date(),
      };
      (l((Y) => [...Y, M]), u(""), f(true), b(null));
      try {
        const Y = await api.post("/chat", {
          productId: a,
          userId: n,
          message: M.content,
        });
        (l((R) => [
          ...R,
          {
            id: Date.now().toString(),
            sender: "assistant",
            content: Y.data.response,
            timestamp: new Date(),
          },
        ]),
          p(Y.data.remaining));
      } catch (Y) {
        (console.error("Error sending message:", Y),
          Y.response && Y.response.status === 403
            ? b("Message limit reached. You cannot send more messages for this product.")
            : b("Failed to send message. Please try again later."),
          l((R) => R.slice(0, R.length - 1)));
      } finally {
        f(false);
      }
    };
  return (
    <div className={"bg-white rounded-lg shadow-md overflow-hidden max-w-full"}>
      <div className={"bg-indigo-600 text-white px-4 py-3 flex justify-between items-center"}>
        <h3 className={"font-medium flex items-center min-w-0 flex-1"}>
          <svg
            className={"w-5 h-5 mr-2 flex-shrink-0"}
            fill={"none"}
            stroke={"currentColor"}
            viewBox={"0 0 24 24"}
            xmlns={"http://www.w3.org/2000/svg"}
          >
            <path
              strokeLinecap={"round"}
              strokeLinejoin={"round"}
              strokeWidth={"2"}
              d={
                "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
              }
            />
          </svg>
          <span className={"truncate"}>{"Product Support Chat"}</span>
        </h3>
        <span
          className={
            "text-xs px-2 py-1 bg-white text-indigo-700 rounded-full flex items-center ml-2 flex-shrink-0"
          }
        >
          <svg
            className={"w-3 h-3 mr-1"}
            fill={"none"}
            stroke={"currentColor"}
            viewBox={"0 0 24 24"}
            xmlns={"http://www.w3.org/2000/svg"}
          >
            <path
              strokeLinecap={"round"}
              strokeLinejoin={"round"}
              strokeWidth={"2"}
              d={
                "M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
              }
            />
          </svg>
          <span className={"whitespace-nowrap"}>
            {x}
            {" left"}
          </span>
        </span>
      </div>
      <div className={"h-80 p-4 overflow-y-auto bg-gray-50"}>
        {i.length === 0 ? (
          <div className={"flex flex-col items-center justify-center h-full text-gray-500"}>
            <svg
              className={"w-12 h-12 mb-3"}
              fill={"none"}
              stroke={"currentColor"}
              viewBox={"0 0 24 24"}
              xmlns={"http://www.w3.org/2000/svg"}
            >
              <path
                strokeLinecap={"round"}
                strokeLinejoin={"round"}
                strokeWidth={"1.5"}
                d={
                  "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                }
              />
            </svg>
            <p className={"text-center text-sm px-4"}>
              {"Ask questions about this product and get AI-powered assistance."}
              <br />
              {"You have "}
              {x}
              {" messages available."}
            </p>
          </div>
        ) : (
          i.map((O) => (
            <div
              key={O.id}
              className={`mb-4 flex ${O.sender === "user" ? "justify-end" : "justify-start"}`}
            >
              <div
                className={`relative w-full max-w-[85%] sm:max-w-xs md:max-w-md rounded-lg px-4 py-2 ${O.sender === "user" ? "bg-indigo-100 text-indigo-900" : "bg-white border border-gray-200 text-gray-800"}`}
              >
                {O.sender === "assistant" && (
                  <button
                    onClick={() => C(O.content, O.id)}
                    className={
                      "absolute top-2 right-2 p-1 text-gray-400 hover:text-gray-600 rounded-md hover:bg-gray-100 z-10"
                    }
                    title={"Copy message"}
                  >
                    {y === O.id ? (
                      <svg
                        className={"w-4 h-4"}
                        fill={"none"}
                        stroke={"currentColor"}
                        viewBox={"0 0 24 24"}
                        xmlns={"http://www.w3.org/2000/svg"}
                      >
                        <path
                          strokeLinecap={"round"}
                          strokeLinejoin={"round"}
                          strokeWidth={"2"}
                          d={"M5 13l4 4L19 7"}
                        />
                      </svg>
                    ) : (
                      <svg
                        className={"w-4 h-4"}
                        fill={"none"}
                        stroke={"currentColor"}
                        viewBox={"0 0 24 24"}
                        xmlns={"http://www.w3.org/2000/svg"}
                      >
                        <path
                          strokeLinecap={"round"}
                          strokeLinejoin={"round"}
                          strokeWidth={"2"}
                          d={
                            "M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
                          }
                        />
                      </svg>
                    )}
                  </button>
                )}
                <div
                  className={
                    "text-sm whitespace-pre-wrap break-words overflow-hidden message-content"
                  }
                  style={{
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                    hyphens: "auto",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: T(O.content),
                  }}
                />
                <div
                  className={"flex justify-between items-center mt-2 pt-1 border-t border-gray-100"}
                >
                  <p className={"text-xs text-gray-500 flex-shrink-0"}>
                    {new Date(O.timestamp).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </p>
                  {O.sender === "assistant" && (
                    <span className={"text-xs text-indigo-600 flex items-center ml-2"}>
                      <svg
                        className={"w-3 h-3 mr-1 flex-shrink-0"}
                        fill={"none"}
                        stroke={"currentColor"}
                        viewBox={"0 0 24 24"}
                        xmlns={"http://www.w3.org/2000/svg"}
                      >
                        <path
                          strokeLinecap={"round"}
                          strokeLinejoin={"round"}
                          strokeWidth={"2"}
                          d={
                            "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                          }
                        />
                      </svg>
                      <span className={"hidden sm:inline"}>{"AI Response"}</span>
                      <span className={"sm:hidden"}>{"AI"}</span>
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))
        )}
        {m && (
          <div className={"flex justify-start mb-3"}>
            <div className={"bg-white border border-gray-200 rounded-lg px-4 py-2"}>
              <div className={"flex space-x-2"}>
                <div className={"w-2 h-2 rounded-full bg-indigo-400 animate-bounce"} />
                <div className={"w-2 h-2 rounded-full bg-indigo-400 animate-bounce delay-75"} />
                <div className={"w-2 h-2 rounded-full bg-indigo-400 animate-bounce delay-150"} />
              </div>
            </div>
          </div>
        )}
        {g && (
          <div
            className={
              "p-3 mb-3 bg-red-50 border-l-4 border-red-500 text-red-700 text-sm break-words"
            }
          >
            <p className={"break-words"}>{g}</p>
          </div>
        )}
        <div ref={N} />
      </div>
      <form onSubmit={A} className={"border-t border-gray-200 p-4"}>
        <div className={"flex"}>
          <input
            type={"text"}
            value={c}
            onChange={(O) => u(O.target.value)}
            placeholder={"Type your question here..."}
            disabled={m || x <= 0}
            className={
              "flex-1 min-w-0 px-4 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent disabled:bg-gray-100 disabled:text-gray-500"
            }
          />
          <button
            type={"submit"}
            disabled={m || !c.trim() || x <= 0}
            className={
              "bg-indigo-600 text-white px-4 py-2 rounded-r-md hover:bg-indigo-700 transition-colors disabled:bg-indigo-300 disabled:cursor-not-allowed flex-shrink-0"
            }
          >
            {m ? (
              <svg
                className={"animate-spin h-5 w-5"}
                xmlns={"http://www.w3.org/2000/svg"}
                fill={"none"}
                viewBox={"0 0 24 24"}
              >
                <circle
                  className={"opacity-25"}
                  cx={"12"}
                  cy={"12"}
                  r={"10"}
                  stroke={"currentColor"}
                  strokeWidth={"4"}
                />
                <path
                  className={"opacity-75"}
                  fill={"currentColor"}
                  d={
                    "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  }
                />
              </svg>
            ) : (
              <svg
                className={"w-5 h-5"}
                fill={"none"}
                stroke={"currentColor"}
                viewBox={"0 0 24 24"}
                xmlns={"http://www.w3.org/2000/svg"}
              >
                <path
                  strokeLinecap={"round"}
                  strokeLinejoin={"round"}
                  strokeWidth={"2"}
                  d={"M13 5l7 7-7 7M5 5l7 7-7 7"}
                />
              </svg>
            )}
          </button>
        </div>
        {x <= 5 && x > 0 && (
          <p className={"mt-2 text-xs text-amber-600 flex items-start"}>
            <svg
              className={"w-3 h-3 mr-1 mt-0.5 flex-shrink-0"}
              fill={"none"}
              stroke={"currentColor"}
              viewBox={"0 0 24 24"}
              xmlns={"http://www.w3.org/2000/svg"}
            >
              <path
                strokeLinecap={"round"}
                strokeLinejoin={"round"}
                strokeWidth={"2"}
                d={
                  "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                }
              />
            </svg>
            <span className={"break-words"}>
              {"You have only "}
              {x}
              {" messages left for this product."}
            </span>
          </p>
        )}
        {x <= 0 && (
          <p className={"mt-2 text-xs text-red-600 flex items-start"}>
            <svg
              className={"w-3 h-3 mr-1 mt-0.5 flex-shrink-0"}
              fill={"none"}
              stroke={"currentColor"}
              viewBox={"0 0 24 24"}
              xmlns={"http://www.w3.org/2000/svg"}
            >
              <path
                strokeLinecap={"round"}
                strokeLinejoin={"round"}
                strokeWidth={"2"}
                d={"M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}
              />
            </svg>
            <span className={"break-words"}>
              {"You have reached the maximum number of messages for this product."}
            </span>
          </p>
        )}
      </form>
    </div>
  );
};
export { ProductSupportChat };
